import { EmptyProps } from '@next/arable-lib/external-resource';
import { createHttpActionsWithInitiate } from '@next/arable-lib/shared';

import { SoilType } from '../models/soil-type.models';

export const [loadSoilTypesInitiate, loadSoilTypes, loadSoilTypesSuccess, loadSoilTypesFailed] = createHttpActionsWithInitiate<
  EmptyProps,
  void,
  { soilTypes: SoilType[] },
  void
>('Load Soil Types');
